function getSection() {
  return document.querySelector('[data-section]').getAttribute('data-section').toUpperCase();
}

function promo(creative, bannerType) {
  var section = getSection();
  var promotion = {
    id: section + "-" + bannerType,
    name: section + "-" + bannerType,
    creative: creative,
    position: section
  };
  return promotion;
}

function addImpressions() {
  var dlImpressions = [];
  var banners = Array.prototype.slice.call(document.querySelectorAll('.banner'));
  if (banners.length > 0) {
    banners.forEach(function(banner) {
      dlImpressions.push(callPromo(banner));
    });
  }
  return dlImpressions;
}

function getUrlWithoutProtocol(url) {
  // Get image url without protocol f.e.x 'images.elisaviihde.fi/1920x250/elisaviihde_dp_050616_1920x250.jpg'
  var urlPathRegexp = /\s*["']?[a-z0-9]*:*[\/\/]*([^"']+)["']?\s*/gi,
    match = urlPathRegexp.exec(url);
  return match ? match[1] : "";
}

function callPromo(banner) {
  var bannerImage = getUrlWithoutProtocol(banner.querySelector('.banner-img').src),
    bannerType = banner.attributes["data-banner-type"].value.toUpperCase();

  return promo(bannerImage, bannerType);
}

export default {
  addImpressions: addImpressions,
  trackPurchase: function (args) {
    var transactionId = Date.now();
    return {
      event: 'ec:purchase',
      ecommerce: {
        purchase: {
          actionField: {
            id: transactionId,
            revenue: args.price
          },
          products: [args]
        }
      }
    };
  },
  trackProductView: function (productId, name) {
    return {
      event: 'ec:detail',
      ecommerce: {
        detail: {
          products: [{
            id: productId,
            name: name
          }]
        }
      }
    };
  },
  trackCheckout: function (step, option, productObj) {
    return {
      event: 'ec:checkout',
      ecommerce: {
        checkout: {
          actionField: {
            step: step,
            option: option || undefined
          },
          products: productObj ? [productObj] : []
        }
      }
    };
  },
  trackBannerClick: function (bannerImage, bannerType) {
    var promoClickProd = promo(getUrlWithoutProtocol(bannerImage), bannerType);
    return {
      event: 'ec:promoClick',
      ecommerce: {
        promoClick: {
          promotions: [promoClickProd]
        }
      }
    };
  },
  getSection: getSection
};



// WEBPACK FOOTER //
// ./web/js/ec.js